import styled from '@emotion/styled';
import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import { withConfig } from 'src/withConfig';

export const StaticPageWrapper = styled('div', { label: 'StaticPageWrapper' })`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StaticPageInnerWrapper = withConfig(theme => styled('div', { label: 'StaticPageInnerWrapper' })`
    background-color: ${theme.star.accountDrawer.bgColorSecondary};
    flex: 1 0 0%;
    height: 100%;
    line-height: 1.6;
    overflow-x: hidden;
    padding: 10px 16px 16px 16px;
    h6,
    h5,
    h4,
    h3,
    h2,
    h1 {
        color: ${theme.star.staticPage.txtColor};
        font-weight: ${theme.star.fontWeight.medium};
        line-height: 1.3;
        margin: 0 0 5px 0;
        padding: 0;
    }
    p {
        margin-top: 0;
        line-height: 1.6;
    }
    ul {
        padding: 5px 0;
    }
    ul > li {
        padding-left: 15px;
        position: relative;
        margin-bottom: 10px;
    }
    ul > li::before {
        background: ${theme.star.staticPage.bgColorSecondary};
        border-radius: 50px;
        content: '';
        height: 5px;
        left: 0;
        position: absolute;
        top: 5px;
        width: 5px;
    }
    ol {
        list-style: decimal;
        list-style-position: outside;
        margin-left: 20px;
    }
    ol > li {
        margin-bottom: 10px;
    }
`);

export const HeaderWrapper = withConfig(theme => styled('header', { label: 'HeaderWrapper' })`
    display: flex;
    flex: 0 0 48px;
    align-items: center;
    position: relative;
    background: ${theme.star.sidebar.bgColor};
    color: ${theme.star.sidebar.txtColor};
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.3;
`);

export const TitleWrapper = withConfig(theme => styled('h3', { label: 'TitleWrapper' })`
    color: ${theme.star.sidebar.txtColor};
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    margin: 0 0 0 16px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`);

export const HeaderCloseIcon = styled(CloseIcon, { label: 'HeaderCloseIcon' })`
    cursor: pointer;
    fill: currentcolor;
    margin-left: auto;
    padding: 14px;
    width: 48px;
`;
